import { useSelector } from 'react-redux';
import React from 'react';
import { Redirect } from 'react-router';
import { ChildrenProps, ReduxState } from '../../types';
import useAuth from '../../hooks/useAuth';
import SplashScreen from '../Loading/SplashScreen';

function ClientAuthGuard({ children, admittedUserTypes, admittedUserRoles }: ChildrenProps
& { admittedUserTypes?: string[], admittedUserRoles?: string[] }): JSX.Element {
  const { isLoading } = useAuth();
  const account = useSelector((state: ReduxState) => state.account);

  if (isLoading) {
    return <SplashScreen />;
  }

  if (!account.user) {
    return <Redirect to="/login" />;
  }

  // Si uno desea no tener un guard via roles, simplemente no definir roles
  if (admittedUserTypes && !admittedUserTypes.includes(account.user.type || '')) {
    return <Redirect to="/sin-autorizacion" />;
  }

  if (admittedUserRoles && !admittedUserRoles.includes(account.user.role || '')) {
    return <Redirect to="/sin-autorizacion" />;
  }

  return <>{children}</>;
}

export default ClientAuthGuard;
